


export type PushType = 'Direct' | 'News';

export const PushType = {
    Direct: 'Direct' as PushType,
    News: 'News' as PushType
};

